import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { ALL_DEFAULTS } from "../lib/textDefaults";

const TextsContext = createContext({ t: (k, fb) => fb, overrides: {}, reload: () => {} });

export function TextsProvider({ children }) {
  const [overrides, setOverrides] = useState({});

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/site-content/ui_texts");
      if (data && data.value && typeof data.value === "object") {
        setOverrides(data.value);
      }
    } catch (err) { console.error("ui_texts load failed:", err); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const t = useCallback((key, fallback) => {
    if (overrides[key] !== undefined && overrides[key] !== "") return overrides[key];
    if (fallback !== undefined) return fallback;
    return ALL_DEFAULTS[key] ?? key;
  }, [overrides]);

  return (
    <TextsContext.Provider value={{ t, overrides, reload }}>
      {children}
    </TextsContext.Provider>
  );
}

export const useTexts = () => useContext(TextsContext);
export const useText = () => useContext(TextsContext).t;
